var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Datos del Informe de Referido", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "row my-3" },
        [
          _c("info-field", {
            staticClass: "col-3",
            attrs: { label: "Solicitante:", value: _vm.model.requestedBy }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: { label: "Rol en Sistema:", value: _vm.model.systemRole }
          }),
          _c("info-field", {
            staticClass: "col-3",
            attrs: {
              "format-type": "date",
              label: "Fecha de solicitud:",
              value: _vm.model.requestDate
            }
          }),
          _vm.isReadOnly
            ? _c("div", { staticClass: "col-3 d-flex flex-column" }, [
                _c("label", { staticClass: "text-muted" }, [
                  _vm._v("Fecha del informe:")
                ]),
                _c("span", [
                  _vm._v(_vm._s(_vm._f("date")(_vm.model.reportDate)))
                ])
              ])
            : _c(
                "div",
                { staticClass: "col-3" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-date-picker", {
                              attrs: {
                                id: "reportDate",
                                "class-container": "w-100",
                                "custom-error-msg": "El campo es requerido.",
                                disabled: _vm.isReadOnly,
                                error: errors[0],
                                label: "Fecha del informe:",
                                placeholder: "DD/MM/YYYY"
                              },
                              model: {
                                value: _vm.model.reportDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "reportDate", $$v)
                                },
                                expression: "model.reportDate"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
          _c(
            "div",
            { staticClass: "col-12 flex-column mt-3" },
            [
              _c("div", { staticClass: "color-secondary-6 font-14 mb-2" }, [
                _vm._v(" Fecha de Intervenciones: ")
              ]),
              _vm._l(_vm.model.interventionDates, function(item) {
                return _c(
                  "div",
                  { key: item.id, staticClass: "condition-pill mr-2 mb-2" },
                  [_c("span", [_vm._v(_vm._s(_vm._f("date")(item)))])]
                )
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }